import React from 'react';
export default class WarehouseSection extends React.Component {
    render() {
        return (
                <section id="warehouse-section" className="section warehouse-section  d-flex align-items-center text-center">
                    <div className="container">
                        <img alt="Warehouse" src="/img/home.svg" />
                        <h2>
                            <span className="darkred">PICK-UP FROM OUR WAREHOUSE</span>
                        </h2>
                        <p>
                            Our warehouse is located in Homebush West in New South Wales, Australia. Most items are available for pickup between 8:00am-4:00pm, Monday to Friday. If your order is bulky, call or email us 24 hours in advance. We will pick and pack your order and set it aside in our pickup area of our warehouse. 
                        </p>
                
                        <h4><strong>Our address for pick up is: </strong></h4>
                        <p>
                            36/159 Arthur Street,<br/> Homebush West NSW 2140<br/>  Australia 
                        </p>
                    </div>
                </section>
                )
    }
}



// WEBPACK FOOTER //
// ./src/components/Home/Warehouse-Section.js